export default {
  width: 9,
  height: 9,
  stroke: true,
  svg: `
  <g fill="none" fill-rule="evenodd" stroke-linecap="square" stroke-width="2">
    <path d="M7 2L2 7M7 7L2 2"/>
  </g>`
}
